import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import withTranslations from '../../../../common/components/with-translations';

const styles = (theme) => ({
  container: {
    margin: '40px auto 30px auto',
    maxWidth: '1000px',
    padding: '0 16px'
  },
  heading: {
    textAlign: 'center',
    color: '#000',
    fontSize: '1.125rem',
    fontWeight: 600,
    lineHeight: 1.375,
    marginBottom: '12px'
  },
  image: {
    display: 'block',
    margin: '0 auto',
    width: '75%',
    maxWidth: '600px'
  }
});

// Hardcoded stand-in for the properties list, shown when an application turns on
// `useAlternateProperties`: a line of copy above the "One Account" logo strip.
class AlternateProperties extends React.Component {

  render() {
    const { classes, t } = this.props;
    const publicDir = !window.globals || !window.globals.gidPublic ? '' : window.globals.gidPublic;
    const image = 'One Account_Black.svg';

    return (
      <Grid className={classes.container} container spacing={0} justifyContent="center">
        <Grid item xs={12}>
          <Typography className={classes.heading} component="p">
            <span>{t('alternateProperties.oneAccount')}</span>
            <br />
            {t('alternateProperties.tagline')}
          </Typography>
          <img className={classes.image} src={encodeURI(`${publicDir}/img/${image}`)} alt={t('alternateProperties.imageAlt')} />
        </Grid>
      </Grid>
    );
  }
}

export default withTranslations(withStyles(styles)(AlternateProperties));
